export default function (state, val) {
    val.ReportsList.forEach(i=>{
        i.fields = [];
    });
    state.items = val.ReportsList;
}